import { postbackPatterns } from '@/utils/constants';

function generatePostbackParameters(advertiserId, postbackConfig) {
  const keys = Object.keys(postbackConfig);
  let postBackBase;
  if (keys.length > 0) {
    // eslint-disable-next-line prefer-destructuring
    postBackBase = postbackConfig[keys[0]];
  } else {
    postBackBase = '';
  }
  const parts = postBackBase.split('?');
  const parameters = [];
  const pathParameters = parts[0].match(postbackPatterns.PLACEHOLDER_PATTERN) || [];
  const queryParameters = parts[1].match(postbackPatterns.PAIR_PATTERN) || [];

  pathParameters.forEach(param => parameters.push(param.replace(postbackPatterns.PLACEHOLDER_PATTERN, '$1:{$1}')));
  queryParameters.forEach(param => parameters.push(param.replace(postbackPatterns.PAIR_PATTERN, '$2:{$1}')));

  return parameters.filter(param => !postbackPatterns.PRE_DEF_PATTERN.test(param)).join(';');
}

function b64EncodeUnicode(str) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    (match, p1) => String.fromCharCode(`0x${p1}`)));
}

export {
  generatePostbackParameters, b64EncodeUnicode,
};
